import { render, staticRenderFns } from "./AtfQuestion.vue?vue&type=template&id=ad09a3be&scoped=true&"
import script from "./AtfQuestion.vue?vue&type=script&lang=js&"
export * from "./AtfQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AtfQuestion.vue?vue&type=style&index=0&id=ad09a3be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad09a3be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VIcon,VRow,VSubheader})
